import alert from '@/plugins/alert';
import api from '@/plugins/api';
import config from '@/plugins/config';
import globalComponents from '@/plugins/global-components';
import globalFilters from '@/plugins/global-filters';
import highcharts from '@/plugins/highcharts';
import http from '@/plugins/http';
import layouts from '@/plugins/layouts';
import mask from '@/plugins/mask';
import router from '@/plugins/router';
import storage from '@/plugins/storage';
import store from '@/plugins/store';
import vCalendar from '@/plugins/v-calendar';
import vClickaway from '@/plugins/v-clickaway';
import vDatePicker from '@/plugins/v-date-picker';
import vMarkdown from '@/plugins/v-markdown';
import vMarquee from '@/plugins/v-marquee';
import vModal from '@/plugins/v-modal';
import vToast from '@/plugins/v-toast';
import vToggleButton from '@/plugins/v-toggle-button';
import vTooltip from '@/plugins/v-tooltip';
import veeValidate from '@/plugins/vee-validate';

const plugins = {
  store,
  router,
  storage,
  http,
  api,
  globalFilters,
  veeValidate,
  vToast,
  vTooltip,
  alert,
  mask,
  globalComponents,
  layouts,
  highcharts,
  vCalendar,
  vClickaway,
  vDatePicker,
  vModal,
  vMarkdown,
  vToggleButton,
  config,
  vMarquee,
};

export const install = (Vue) => {
  // Install all custom plugins
  Object.values(plugins).forEach((plugin) => {
    if (plugin.install) {
      Vue.use(plugin);
    }

    if (plugin.expose) {
      plugin.expose(Vue);
    }
  });
};
